// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const ResourceContentionIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon
      data-iconname="ResourceContentionIcon"
      ref={forwardedRef}
      {...props}
    >
      <path d="M3.285 5.93C4.713 4.18 6.925 2.921 10 2.921c3.08 0 5.298 1.291 6.726 3.052 1.41 1.736 2.038 3.909 2.024 5.704l-.006.744h-4.496v-.75c0-.397-.182-1.456-.822-2.396C12.816 8.379 11.787 7.58 10 7.58c-1.805 0-2.827.761-3.424 1.619-.628.9-.812 1.95-.812 2.459v.747l-4.514.02V11.67c0-1.842.625-4.014 2.035-5.74M2.79 10.918l1.536-.007a6.3 6.3 0 0 1 1.018-2.57C6.209 7.101 7.68 6.081 10 6.081c1.04 0 1.91.215 2.629.566l.758-1.482C12.455 4.702 11.334 4.421 10 4.421c-2.618 0-4.405 1.052-5.554 2.458-.98 1.202-1.511 2.684-1.655 4.039" />
      <path d="M10.75 13.036V9.92a.75.75 0 0 0-1.5 0v3.115a2.501 2.501 0 1 0 1.5 0M10 14.42a1 1 0 1 1 0 2 1 1 0 0 1 0-2" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const ResourceContentionIcon = /* @__PURE__ */ Object.assign(
  ResourceContentionIconComponent,
  { displayName: 'ResourceContentionIcon' },
);
